import { Box, Text, Layer, Button } from "grommet";
import { Table } from "grommet-icons";
import React from "react";
import modNumeration from "../functions/modNumeration";
import useTableau from "../hooks/useTableau";
import useTableauRecord from "../hooks/useTableauRecord";
import useTocRecord from "../hooks/useTocRecord";
import TableauUnit from "./TableauUnit";

const TocUnitData = (props: any) => {
    let aToc = props.atoc;
    let aBook = props.abook
    console.log('TocUnitData',props, aToc, aBook)
    const [tables, setTables] = React.useState([]);
    const [records, setRecords] = React.useState([]);

    React.useEffect(() => {
      // import table and record
        const getTocContents = async () => {
            let resT = await useTableau.getTableauxByTocId(aToc.tocid);
            let resR = await useTocRecord.getTocRecordsById(aToc.tocid);
            console.log('TocUnitData-res', resT, resR)
            if (resT.result) {
                // console.log('result-tableaux', resT.tableaux)
                setTables(resT.tableaux);
            }
            if (resR.result) {
                setRecords(resR.tocrecords);
            }
        };
        getTocContents()
    }, []);




    const OneTable = (props: any) => {
        let aTable = props.table;
        // console.log('OneTable', aTable)
        const [openTable, setOpenTable] = React.useState(0);
        return (<>
          <Box
            align="center"
            direction="row"
            width="full"
            margin={{ vertical: "0px" }}
            style={aTable.tableaurecord_count > 0 ? { cursor: "pointer" } : {cursor:'default'}}
            onClick={() => {setOpenTable(aTable.tableau_id)}}
            focusIndicator={false}
          >
            <Box
              width="50%"
              margin={{ horizontal: "5px" }}
              align="end"
              justify="center"
            >
              <Text
                size="10px" color='grey'
                weight={aTable.tableaurecord_unit > 0 ? "bold" : "normal"}
              >
                {aTable.tableau_title_ko}
              </Text>
            </Box>
            <Box
              width="50%"
              margin={{ horizontal: "5px" }}
              align="center"
              justify="start"
              direction="row"
            >
              <Text size="12px">
                {aTable.tableau_title}
              </Text>
              {aTable.tableaurecord_count > 0 && (
                <Box margin={{ horizontal: "10px" }}>
                  <Table size="10px" color="green" />
                </Box>
              )}
            </Box>
          </Box>
          {openTable!==0 && (
        <Layer
            position="center"
            margin={{top:'130px'}}
            onEsc={()=>setOpenTable(0)}
            onClickOutside={()=>setOpenTable(0)} >
                <TableauUnit tableauinfo={aTable} bookinfo={aBook} />
        </Layer>)}
        </>
        );
    };


    return (
      <>
        <Box
          align="center"
          justify="start"
          width="90%"
          height="90%"
          margin={{ vertical: "0px" }}
        >
          {tables.length > 0 &&
            tables.map((v: any) => (
              <Box
                key={v.tableau_id}
                width="full"
                style={{ minHeight: "25px" }}
                margin={{ vertical: "0px" }}
                align="center"
                justify="center"
              >
                <OneTable table={v} />
              </Box>
            ))}
        </Box>

      </>
    );
}
export default TocUnitData;